import React, { useMemo } from 'react';
import Datestamp from 'vl-common/src/components/Datestamp';
import { TableDataView, HeaderItemType } from 'vl-common/src/components/Table/TableDataView';

export interface RequestAuditDetails {
  id: string;
  date: Date;
  username: string;
  action: string;
}

interface CaseRequestAuditProps {
  requests: RequestAuditDetails[];
}

export const CaseRequestAudit: React.FC<CaseRequestAuditProps> = ({ requests }) => {
  const ColumHeaders = useMemo(
    () => [
      {
        display: 'Request',
        dataSourceKey: 'ireq_id'
      },
      {
        display: 'Date & Time',
        dataSourceKey: 'created_date',
        columnDataFormat: (value: { data: Date }) => (
          <Datestamp date={value.data} format="Date @ Time (long, 24h) - Friday, March 3rd, 2022 @ 08:57" />
        )
      },
      {
        display: 'User',
        dataSourceKey: 'created_by'
      },
      {
        display: 'Description',
        dataSourceKey: 'activity'
      }
    ],
    []
  );

  const handleTableChange = () => {};

  return (
    <div style={{ overflow: 'auto', maxHeight: '50vh' }}>
      <TableDataView
        noDataFoundText="No imaging requests found"
        // @ts-ignore
        headerItems={ColumHeaders as HeaderItemType[]}
        hideColumnList={[]}
        dataSource={requests.map((r, id) => ({ ...r, id })) as any[]}
        handleTableChange={handleTableChange}
      />
    </div>
  );
};

export default CaseRequestAudit;
